'use client';

import _toConsumableArray from "/codebuild/output/src218/src/s3/01/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { mergeVars } from './merge-vars.mjs';
function resolveVars(_ref) {
  var _mergeVars;
  var vars = _ref.vars,
    varsResolver = _ref.varsResolver,
    theme = _ref.theme,
    props = _ref.props,
    stylesCtx = _ref.stylesCtx,
    selector = _ref.selector,
    themeName = _ref.themeName,
    headless = _ref.headless;
  return (_mergeVars = mergeVars([headless ? {} : varsResolver === null || varsResolver === void 0 ? void 0 : varsResolver(theme, props, stylesCtx)].concat(_toConsumableArray(themeName.map(function (name) {
    var _theme$components, _theme$components$var;
    return (_theme$components = theme.components) === null || _theme$components === void 0 || (_theme$components = _theme$components[name]) === null || _theme$components === void 0 || (_theme$components$var = _theme$components.vars) === null || _theme$components$var === void 0 ? void 0 : _theme$components$var.call(_theme$components, theme, props, stylesCtx);
  })), [vars === null || vars === void 0 ? void 0 : vars(theme, props, stylesCtx)]))) === null || _mergeVars === void 0 ? void 0 : _mergeVars[selector];
}
export { resolveVars };